export default {
    'name': 'tooltip-hover',
    'width': '16',
    'height': '16',
    'viewBox': '0 0 16 16',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5ZM9.1501 4.15C9.1501 4.78513 8.63523 5.3 8.0001 5.3C7.36497 5.3 6.8501 4.78513 6.8501 4.15C6.8501 3.51487 7.36497 3 8.0001 3C8.63523 3 9.1501 3.51487 9.1501 4.15ZM8.00012 6.4C8.49718 6.4 8.90012 6.80294 8.90012 7.3V11.8644C8.90012 12.3614 8.49718 12.7644 8.00012 12.7644C7.50307 12.7644 7.10012 12.3614 7.10012 11.8644L7.10012 7.3C7.10012 6.80294 7.50307 6.4 8.00012 6.4Z\' fill=\'#006CFD\'/>'
}
